import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FirebaseProfilePageGuard } from './stallion/firebase/auth/firebase-profile-can-activate.guard';
import { FirebaseSignInPage } from './stallion/firebase/auth/sign-in/firebase-sign-in.page';
import { FirebaseSignUpPageModule } from './stallion/firebase/auth/sign-up/firebase-sign-up.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/stallion',
    pathMatch: 'full'
  },
  {
    path: 'imprint',
    loadChildren: () => import('./stallion/imprint/imprint.module').then( m => m.ImprintPageModule)
  },
  {
    path: 'contactus',
    loadChildren: () => import('./stallion/contact-us/contact-us.module').then( m => m.ContactUsPageModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./stallion/search/stallionsearch.module').then(m => m.StallionsearchPageModule)
  },
  {
    path: 'members',
    canActivate: [FirebaseProfilePageGuard],
    loadChildren: () => import('./stallion/firebase/crud/firebase-crud.module').then(m => m.FirebaseCrudModule)
  },
  {
    path: 'login',
    children: [
      {
          path: "auth",
          children: [
            {
              path: 'sign-in',
              children: [
                {
                    path: '',
                    component: FirebaseSignInPage
                                  //loadChildren: () => import('/sign-in/firebase-sign-in.module').then(m => m.FirebaseSignInPageModule)
                }
              ]
            },
            {
              path: 'sign-up',
              children: [
                {
                  path: '',
                  component: FirebaseSignUpPageModule
                                //loadChildren: () => import('/sign-in/firebase-sign-in.module').then(m => m.FirebaseSignInPageModule)
              }

              ]
              //loadChildren: () => import('./sign-up/firebase-sign-up.module').then(m => m.FirebaseSignUpPageModule)
            },        
      ]
    }
    ]
    //loadChildren: () => import('./stallion/firebase/auth/firebase-auth.module').then(m => m.FirebaseAuthModule)
  },
  {
    path: 'stallion/:stallionId',
    loadChildren: () => import('./stallion/details/stallion-details.module').then(m => m.StallionDetailsPageModule)
  },
  {
    path: 'stallion/:stallionId/contact',
    loadChildren: () => import('./stallion/contact-card/contact-card.module').then(m => m.ContactCardPageModule)
  },
  {
    path: 'stallion',
    loadChildren: () => import('./stallion/listing/stallion-listing.module').then(m => m.StallionListingPageModule)
  },
  {
    path: 'page-not-found',
    loadChildren: () => import('./page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  },
  {
    path: '**',
    redirectTo: 'page-not-found'
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./stallion/contact-us/contact-us.module').then( m => m.ContactUsPageModule)
  }


];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
